<script setup lang="ts">
interface Props {
  sectionTitle: string;
}

defineProps<Props>();
</script>

<template>
  <section class="section-container" :aria-label="sectionTitle">
    <slot></slot>
  </section>
</template>

<style scoped lang="scss">
.section-container {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}
</style>
